import React from 'react';
import '../css/index.css';

export function News() {

    return(
        <section className="News" >
            <div className='News'>
                <div className='Newsword'>
                <h2>We will be holding our weekly meetings this quarter in PDL C-301. Our first meeting will be on October 6 at 5:30pm, but we’ll have a Dawg Daze info session as aforementioned above. Looking forward to seeing you all this year!</h2>
                </div>
            </div>

            <div className='wrapper'>
                <p>Statistics and Probability Association (S.P.A) is the one and only official student organization under the Department of Statistics. S.P.A connects UW students with professionals from diverse backgrounds, providing opportunities and resources for future career development! Both Statistics majors and non-majors are welcome to join the SPA. There is no membership fee, so feel free to participate in our events!</p>
                <h2>To be updated of the most recent activities, please join our official spa discord!</h2>
            </div>

            <div className='Discord'>
            <a href = "https://discord.gg/xEMbHmuRR9"  target = "_blank">
                <img src="./img/discord.png" alt="Italian Trulli"></img>
                </a>
            </div>
            

        </section>
    )
}